<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-select
            v-model="filters.ActivityId"
            placeholder="请输入活动名称"
            :loading="loadingActivityName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            @change="handleActName"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.EAS_State" placeholder="请选择活动状态">
            <el-option
              label="--请选择活动状态--"
              :value="-1"
              key="-1"
            ></el-option>
            <el-option label="报名中" :value="0" key="0"></el-option>
            <el-option label="报名结束" :value="1" key="1"></el-option>
            <el-option label="已举办" :value="2" key="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column
        prop="EA_Title"
        label="活动名称"
      >
        <template slot-scope="scope">
          {{ scope.row.EA_Title }}<br>          
          <span v-if="scope.row.ApplyAwardDeadline" style="color:#009f8d"> 获奖报名截止时间：{{ scope.row.ApplyAwardDeadline }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="HRoot" width="60"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.EA_IsHRootWebShow == 1">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="" label="卓悦会" width="70"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.EA_Source == 1">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="" label="费用" width="70"
        ><template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.EA_Gratis == 0">免费</el-tag>
          <el-tag type="success" v-else>收费</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="" label="默认活动" width="70"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsDefault == 1">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="EA_BroCount"
        label="浏览"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="EA_RegCount"
        label="报名"
        width="50"
      ></el-table-column>
      <el-table-column prop="EA_Weight" label="权重" width="50">
      </el-table-column>
      <el-table-column prop="" label="活动状态" width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.EAS_State == 0">报名中</el-tag>
          <el-tag type="info" v-else-if="scope.row.EAS_State == 1"
            >报名结束</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.EAS_State == 2"
            >已举办</el-tag
          >
          <el-tag type="warning" v-else>--</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            style="padding-right: 10px"
            v-for="item in tableButtonList"
            v-bind:key="item.id"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              :disabled="(item.name == '结束报名' && scope.row.EAS_State === 1)"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 活动资讯 EDM 弹窗 -->
    <el-dialog
      title="活动资讯EDM生成"
      :visible.sync="dislogEdm"
      width="60%"
      :close-on-click-modal="false"
      :before-close="handleEDMClose"
    >
      <el-table-draggable>
        <el-table
          :data="tabEdmData"
          border=""
          row-key="ActivityIDStr"
          ref="tabEdmData"
          class="custom-tbl"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="EA_Title" label="活动标题"></el-table-column>
          <el-table-column
            prop="EAS_StartTime"
            label="活动开始时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="EAS_CityName"
            label="地址"
            width="100"
          ></el-table-column>
        </el-table>
      </el-table-draggable>
      <el-button type="primary" @click="primaryEdm" class="primaryEdm"
        >生成EDM文件</el-button
      >
    </el-dialog>
  </section>
</template>

<script>
import {
  getActivityList,
  getActivityPageList,
  ActivityEDMList,
  ActivityEndReg,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import store from '@/store'
import ElTableDraggable from 'el-table-draggable'
import { set } from 'vue'
export default {
  data() {
    return {
      listLoading: false,
      topButtonList: [],
      tableButtonList: [],
      filters: {
        EAS_State: 0,
        ActivityId: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      activityList: [], // 适用活动
      loadingActivityName: false, // 适用活动 加载效果
      dislogEdm: false, // 活动资讯 EDM 弹窗
      tabEdmData: [], // 生成edm的数据
      multipleSelection: [], // tab选中的数据
      sortedMultipleSelection: [], // tab选中的数据
    }
  },
  components: {
    // Toolbar
    ElTableDraggable,
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.filters.PageIndex = val
      this.handleQuery()
    },
    // 新增活动
    handleAdd() {
      store.commit('saveCurActivityId', '0')
      this.$router.push(`/DetpActivity/ActivityInfo`)      
    },
    
    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true
        setTimeout(() => {
          getActivityList(query).then((res) => {
            if (res.data.success) {
              this.activityList = res.data.response
              this.loadingActivityName = false
            }
          })
        }, 500)
      }
    },
    // 使用活动 选择事件，获取选择数据的值
    handleActName(val) {
      this.ruleForm.ActivityId = val
      this.ruleForm.ActivityName = val
        ? this.activityList.find((ele) => ele.ActivityId === val).ActivityName
        : ''
    },

    // 结束报名
    handleRegCloses(){
      this.$confirm('结束报名, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ActivityEndReg(this.currentRow.ActivityIDStr).then((res) => {
          if(res.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          } else {
            this.$message({
              type: 'success',
              message: '操作失败!'
            });
          }
        })
        this.handleQuery();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },

    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getActivityPageList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 详情按钮
    handleInfo() {
      store.commit('saveCurActivityId', this.currentRow.ActivityIDStr)
      this.$router.push(`/DetpActivity/ActivityInfo`)
    },

    // 活动资讯 EDM 弹窗
    handleEDMButton() {
      this.dislogEdm = true
      ActivityEDMList().then((res) => {
        if (res.data.success) {
          this.tabEdmData = res.data.response
        } else {
          this.$message({
            message: '数据获取失败！',
            type: 'error',
          })
        }
      })
    },
    // 生成 EDM 文件
    primaryEdm() {
      if (this.sortedMultipleSelection.length < 1) {
        this.$message({
          message: '请选择要生成EDM的活动！',
          type: 'error',
        })
        return
      }
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/Activity/DownloadEDM`
      var xhr = new XMLHttpRequest()
      var params = JSON.stringify({
        ActivityIDList: this.sortedMultipleSelection,
      })
      xhr.open('post', url, true)
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '活动EDM.html' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(params) // 发送ajax请求
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((a) => a.ActivityIDStr)
      this.sortedMultipleSelection = this.tabEdmData
        .filter((item) => this.multipleSelection.includes(item.ActivityIDStr))
        .map((a) => a.ActivityIDStr)
    },
    handleEDMClose() {
      this.dislogEdm = false
    },
  },
  mounted() {
    this.handleQuery()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
  watch: {
    tabEdmData: {
      handler(val) {
        this.sortedMultipleSelection = this.tabEdmData
          .filter((item) => this.multipleSelection.includes(item.ActivityIDStr))
          .map((a) => a.ActivityIDStr)
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.primaryEdm {
  margin: 30px auto;
  display: block;
}
</style>
